module.exports = __webpack_public_path__ + "static/media/CICLO_3_PROSPERIDAD_DIGITAL_2022.b6ca3e4a.jpg";